const AIStats = ({ aiOverallStats, aiMessageStats, aiFeedbackStats }) => {
  return (
    <div className="mt-10 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
      {[
        {
          title: "User Overview",
          color: "text-blue-500",
          stats: [
            { label: "Unique Users", value: aiOverallStats?.totalUsers || 0 },
            { label: "Total Sessions", value: aiOverallStats?.totalSessions || 0 },
            { label: "Likes", value: aiFeedbackStats?.like || 0 },
            { label: "Dislikes", value: aiFeedbackStats?.dislike || 0 },
          ],
        },
        {
          title: "Message Stats",
          color: "text-green-500",
          stats: [
            { label: "Total Messages", value: aiOverallStats?.totalMessages || 0 },
            { label: "Avg. per Session", value: aiMessageStats?.perSession || 0 },
            { label: "User Messages", value: aiMessageStats?.userMessages || 0 },
            { label: "Model Messages", value: aiMessageStats?.modelMessages || 0 },
          ],
        },
      ].map((section, idx) => (
        <div
          key={idx}
          className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white/70 dark:bg-gray-900/60 backdrop-blur-md shadow-lg p-6 transition hover:shadow-2xl"
        >
          <h2 className={`text-xl font-bold mb-4 ${section.color}`}>{section.title}</h2>
          <div className="space-y-3 text-sm text-gray-800 dark:text-gray-200">
            {section.stats.map((stat, i) => (
              <div key={i} className="flex justify-between items-center">
                <span>{stat.label}</span>
                <span className="font-semibold text-base">{stat.value}</span>
              </div>
            ))}
          </div>
        </div>
      ))}

      <div className="col-span-1 md:col-span-2 xl:col-span-2 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white/70 dark:bg-gray-900/60 backdrop-blur-md shadow-lg p-6 transition hover:shadow-2xl">
        <h2 className="text-xl font-bold text-red-500 mb-4">Dislike Reviews</h2>
        {aiFeedbackStats?.reviews?.length > 0 ? (
          <ul className="list-disc list-inside space-y-2 text-sm text-gray-700 dark:text-gray-300 max-h-56 overflow-y-auto">
            {aiFeedbackStats.reviews.map((review, index) => (
              <li key={index}>{review}</li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-600 dark:text-gray-400 text-sm italic">No reviews yet.</p>
        )}
      </div>
    </div>
  );
};

export default AIStats;
